<template>
  <div class="fluidAutoComplete flex-group">
    <AutoComplete
      :formData="formData"
      :tabindex="tabindex"
      store="Fluid"
      :mapping="mapping"
      :removeOptionsLimit="true"
      :hasDescription="true"
      :fluidInfo="{ fluidTypeID: startingFluidTypeID }"
      placeholder="Select Fluid"
      @update="changeFluid"
      @fluid-selected="fluidSelected"
      ref="autoComplete"
    >
      Fluid
    </AutoComplete>
    <FluidAutoCompleteAddEdit
      :fluidData="fluidData"
      :tabindex="addTabindex"
      @added-fluid="addedFluid"
      :startingFluidTypeID="startingFluidTypeID"
    />
  </div>
</template>

<script>
import FluidAutoCompleteAddEdit from './FluidAutoCompleteAddEdit.vue';
import Endpoint from '../../constants/api/endpoint/endpoint.constants';
import AutoComplete from '../shared/AutoComplete.vue';
import AjaxDataService from '../../../services/ajax.service';

export default {
  name: 'FluidAutoComplete',
  components: {
    FluidAutoCompleteAddEdit,
    AutoComplete
  },
  data() {
    return {
      getFluidEndpoint: Endpoint.Fluid.getById,
      fluidData: {}
    };
  },
  methods: {
    changeFluid(fluid) {
      if (fluid && fluid.fluidID) {
        this.getFluid(fluid.fluidID);
      }
    },
    addedFluid(fluid) {
      this.fluidData = fluid;
      this.$emit('added-fluid', fluid);
      this.$refs.autoComplete.selectAddedItem(fluid);
    },
    setFluidAfterAdd(fluid) {
      this.fluidData = fluid;
      this.$refs.autoComplete.selectAddedItem(this.fluidData);
    },
    fluidSelected(fluidID) {
      this.$emit('fluid-selected-oil', fluidID);
    },
    async getFluid(fluidID) {
      try {
        const response = await AjaxDataService.getData(this.getFluidEndpoint, { fluidID });
        if (response && response.data) {
          this.fluidData = response.data;
        } else {
          this.fluidData = {};
        }
      } catch (error) {
        this.fluidData = {};
      }
    }
  },
  watch: {
    'formData.fluidID': {
      async handler(newVal, oldVal) {
        if (newVal == null || newVal == undefined || newVal == oldVal) return;
        await this.getFluid(newVal);
        this.$emit('fluid-selected-oil', newVal);
      }
    }
  },
  props: {
    mapping: {
      type: Object,
      required: true
    },
    formData: {
      type: Object,
      required: true
    },
    addTabindex: {
      type: Number
    },
    tabindex: {
      type: Number,
      default: 0
    },
    startingFluidTypeID: {
      type: Number
    }
  }
};
</script>

<style lang="scss" scoped>
.fluidAutoComplete {
  align-items: center;
  display: flex;
  padding-right: 20px;
}

:deep(.autocomplete) {
  flex-grow: 1;
}
</style>
